import React from 'react';
import styles from './paymentModal.module.css';
import { InputNumber } from 'antd';

const PaymentModal = ({ visible, amount, setAmount, onOk, onCancel, confirmLoading }) => {
    if (!visible) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <h2 className={styles.title}>Оплатить филиалу</h2>
                <label className={styles.label}>Сумма к оплате</label>
                <InputNumber
                    controls={false}
                    size="large"
                    className={styles.input}
                    placeholder="Введите сумму"
                    min={0}
                    value={amount ?? undefined}
                    onChange={(v) => setAmount(v ?? null)}
                    formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                />
                <div className={styles.actions}>
                    <button className={styles.cancel} type="button" onClick={onCancel}>
                        Отмена
                    </button>
                    <button
                        className={styles.ok}
                        type="button"
                        disabled={!amount || confirmLoading}
                        onClick={onOk}
                    >
                        {confirmLoading ? '...' : 'Оплатить'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentModal;
